import React from 'react';
import classnames from 'classnames';

import { getPlaceholderIcon } from '../../helpers/file';

import type { Asset } from '../../types/asset';

interface MemoryFilesGridItemPreviewProps {
  file: Asset;
};

const MemoryFilesGridItemPreview: React.FC<MemoryFilesGridItemPreviewProps> = ({ file }) => {
  if (!file) {
    return (
      <i className={classnames('fa-light fa-4x', 'fa-file', 'memory-files-grid-item-placeholder')} />
    );
  }

  return (
    <>
      {file.thumbnail ? (
        <>
          <img src={file.thumbnail} alt={file.name} className="memory-files-grid-item-thumbnail" />
          {file.title && (
            <span className="memory-files-grid-item-title memory-files-grid-item-title--with-thumbnail">
              {file.title}
            </span>
          )}
        </>
      ) : (
        <>
          <i className={classnames('fa-light fa-4x', getPlaceholderIcon(file.type), 'memory-files-grid-item-placeholder')} />
          <span className="memory-files-grid-item-title">
            {file.original_filename || file.name}
          </span>
        </>
      )}
    </>
  );
}

export default MemoryFilesGridItemPreview;
